<div class="text-small">
    <h6>Let's Stay in Touch</h6>
    <input type="text" class="form-control" placeholder="Email*" [(ngModel)]="email" />
    <button type="button" (click)="onSignUp()" class="btn bg-bright-gradient mt-2">Sign Up</button>
</div>